import { useNutrition } from "@/hooks/useNutrition";
import { useCache } from "@/hooks/useCache";
import type { Spice } from "@/data/schema";

const formatNutrientName = (name: string): string => {
  return name
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export function Nutrition({ spices }: { spices: Map<number, Spice> }) {
  const { data } = useCache();
  const nutrition = useNutrition({ spices: spices, cache: data });

  return (
    <div>
      {nutrition && (
        <>
        <h3 className="text-base font-semibold text-secondary mb-3 -mx-2 px-2">Nutrition</h3>
        <div className="space-y-1.5">
          {nutrition.map((n, i) => (
            <div className="flex items-center gap-4 py-2 rounded hover:bg-primary/5 transition-colors" key={i}>
              <p className="text-main/80 flex-1 min-w-0 truncate">{formatNutrientName(n.name)}</p>
              <div className="w-20 flex-shrink-0">
                <p className="text-secondary">
                  {n.unit === "mg" ? Math.round(n.amount) : n.amount.toFixed(1)}
                </p>
              </div>
              <div className="w-12 flex-shrink-0">
                <p className="text-main/60 text-sm">{n.unit}</p>
              </div>
            </div>
          ))}
        </div>
        </>
      )}
    </div>
  );
}
